import { GameGenesis } from "@/components/gameThemes/GameGenesis";

const GameGenesisRoute = () => {
  return (
    <div className="w-full min-h-[calc(100vh-3.5rem)] bg-background">
      <div className="container mx-auto px-4 py-4">
        <GameGenesis />
      </div>
    </div>
  );
};

export { GameGenesisRoute }; 